import Vue from "vue";
import { BreakpointProvider } from "./BreakpointProvider";
const breakpointProvider = BreakpointProvider.default;
/**
 * A Vue.js plugin to handle responsive design.
 * <br>Provides a `$responsive` accessor on components instances.
 */
export function ResponsivePlugin() {
    return {
        install(_Vue, options) {
            _Vue.mixin({
                beforeCreate() {
                    if (this.$options.responsive) {
                        Object.defineProperty(this, "$responsive", {
                            value: Vue.observable({
                                breakpoints: breakpointProvider.breakpoints,
                                breakpoint: breakpointProvider.current
                            })
                        });
                        this.$subscribeTo(breakpointProvider.current$, x => {
                            this.$responsive.breakpoint = x;
                        });
                    }
                },
            });
        },
    };
}
//# sourceMappingURL=plugin.js.map